module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('app-page-header'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.contratos,
      "label": "Curso",
      "no-data-text": "Nenhum curso encontrado",
      "clearable": "",
      "item-value": "id",
      "item-text": "descricao"
    },
    on: {
      "input": _vm.selecionaContrato
    },
    model: {
      value: (_vm.contrato),
      callback: function($$v) {
        _vm.contrato = $$v
      },
      expression: "contrato"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.periodos,
      "label": "Período",
      "no-data-text": "Nenhum períodos encontrado",
      "clearable": "",
      "item-value": "periodo",
      "item-text": "descricao"
    },
    on: {
      "input": _vm.selecionaPeriodo
    },
    model: {
      value: (_vm.periodo),
      callback: function($$v) {
        _vm.periodo = $$v
      },
      expression: "periodo"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.frequenciasVazio) ? _c('empty-list', {
    attrs: {
      "title": "Selecione o Curso/Período",
      "description": "As disciplinas serão mostradas conforme o período selecionado"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.frequenciasVazio) ? _c('div', [_c('h3', {
    staticClass: "page-content-title"
  }, [_vm._v("\n              Disciplinas \n              "), _vm._l((_vm.contratos), function(itemContrato) {
    return [(itemContrato.id == _vm.contrato && itemContrato.curriculo.fl_curriculo_competencias && itemContrato.curriculo.ref_curriculo_modelo_avaliacao != 3) ? _c('v-btn', {
      attrs: {
        "fab": "",
        "dark": "",
        "small": "",
        "color": "primary col-2",
        "size": "x-large"
      },
      on: {
        "click": _vm.mostraModuloCompetencias
      }
    }, [_c('i', {
      staticClass: "fas fa-chart-bar"
    })]) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "disciplinas-lista"
  }, _vm._l((_vm.matriculas), function(item) {
    return _c('div', {
      staticClass: "disciplina"
    }, [_c('h3', [_vm._v(_vm._s(item.ref_disciplina) + " - " + _vm._s(item.disciplina))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Professor:")]), _vm._v(" " + _vm._s(item.professores || '-'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Situação:")]), _vm._v(" " + _vm._s(item.estado))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Turno:")]), _vm._v(" " + _vm._s(item.turno || '-'))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Plano de Ensino:")]), _vm._v(" "), _c('a', {
      staticClass: "plano-ensino-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.mostrarPlanoEnsino(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-file-pdf"
    }), _vm._v(" "), _c('span', [_vm._v("Visualizar")])])]), _vm._v(" "), _c('div', {
      staticClass: "dados"
    }, [_c('div', {
      staticClass: "conteudo"
    }, [_c('div', {
      staticClass: "frequencia-dados"
    }, [_c('div', {
      staticClass: "detalhe-frequencia",
      attrs: {
        "id": "detalhe-frequencia",
        "title": _vm.infoDetalheFrequencia
      }
    }, [_c('a', {
      staticClass: "presencas",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.mostrarDetalheFrequencia(item.ref_turma, item.ref_disciplina, item.disciplina)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus-circle"
    })])]), _vm._v(" "), _c('em', [_vm._v("Presenças")]), _vm._v(" "), _c('div', {
      staticClass: "presencas"
    }, [_vm._v(_vm._s(item.frequencias[0].presencas))]), _vm._v(" "), _c('em', [_vm._v("Meias Presenças")]), _vm._v(" "), _c('div', {
      staticClass: "meias-presencas"
    }, [_vm._v(_vm._s(item.frequencias[0].meia_presenca))]), _vm._v(" "), _c('em', [_vm._v("Faltas")]), _vm._v(" "), _c('div', {
      staticClass: "faltas"
    }, [_vm._v(_vm._s(item.frequencias[0].faltas))])]), _vm._v(" "), _c('div', {
      staticClass: "frequencia-dados"
    }, [_c('em', [_vm._v("Frequência")]), _vm._v(" "), _c('div', {
      staticClass: "frequencia"
    }, [_vm._v(_vm._s(item.frequencias[0].frequencia) + "%")])])])]), _vm._v(" "), (item.fl_curriculo_competencias == true && !item.fl_cpp && item.fl_fora_matriz == false) ? _c('div', {
      staticClass: "dados notas"
    }, [_c('v-card', {
      staticClass: "dados",
      attrs: {
        "elevation": "0"
      }
    }, [_vm._l((_vm.competencias.notas_matriculas_individuais), function(matriculas, ref_matricula) {
      return _c('div', _vm._l((matriculas), function(matricula, dados_ref_curriculo_prova) {
        return (ref_matricula == item.ref_matricula) ? _c('div', _vm._l((_vm.descAvaliacao), function(descricao, ref_curriculo_prova) {
          return _c('div', [(ref_curriculo_prova == dados_ref_curriculo_prova) ? _c('div', [_c('v-card-text', {
            staticClass: "pa-1 ma-0",
            attrs: {
              "color": "blue-grey lighten-5"
            }
          }, [_c('strong', {
            staticClass: "descricao-individual"
          }, [_vm._v(_vm._s(descricao))]), _vm._v(" "), _vm._l((matricula), function(notas) {
            return _c('div', [_c('v-flex', {
              attrs: {
                "sm5": ""
              }
            }, [_c('strong', {
              staticClass: "nota-individual"
            }, [_vm._v("Nota " + _vm._s(notas.numero) + ":")]), _vm._v(" " + _vm._s(notas.nota) + "\n                                  ")])], 1)
          })], 2)], 1) : _vm._e()])
        }), 0) : _vm._e()
      }), 0)
    }), _vm._v(" "), _vm._l((_vm.competencias.medias_matriculas_individuais[item.ref_matricula]), function(media) {
      return (_vm.competencias.ref_curriculo_modelo_avaliacao == 3) ? _c('div', [_c('div', {
        staticClass: "pa-1 ma-0",
        attrs: {
          "color": "blue-grey lighten-5"
        }
      }, [_c('v-flex', {
        attrs: {
          "sm0": ""
        }
      }, [_c('div', [_c('strong', {
        staticClass: "descricao-individual"
      }, [_vm._v("MÉDIA")])]), _vm._v(" "), _c('strong', {
        staticClass: "nota-individual"
      }, [_vm._v("Média Parcial:")]), _vm._v(" " + _vm._s((media).toFixed(2)) + "\n                            ")])], 1)]) : _vm._e()
    })], 2)], 1) : (item.fl_curriculo_competencias == false || item.fl_cpp == true) ? _c('div', {
      staticClass: "dados",
      attrs: {
        "color": "blue-grey lighten-5"
      }
    }, [_c('div', {
      staticClass: "conteudo",
      class: {
        '-pos-graduacao': _vm.posGraduacao
      }
    }, [(_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Conceito")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.conceito1 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Nota 1")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota1 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Nota 2")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota2 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Nota 3")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota3 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && !item.media_final) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Média")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.media || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && item.nota_exame) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Exame")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota_exame || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && item.media_final) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Média Final")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.media_final || '-'))])]) : _vm._e()])]) : _c('div', {
      staticClass: "dados",
      attrs: {
        "color": "blue-grey lighten-5"
      }
    }, [_c('div', {
      staticClass: "conteudo",
      class: {
        '-pos-graduacao': _vm.posGraduacao
      }
    }, [(_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Conceito")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.conceito1 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Nota 1")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota1 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Nota 2")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota2 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Nota 3")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota3 || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && !item.media_final) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Média")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.media || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && item.nota_exame) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Exame")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.nota_exame || '-'))])]) : _vm._e(), _vm._v(" "), (!_vm.posGraduacao && item.media_final) ? _c('div', {
      staticClass: "notas"
    }, [_c('em', [_vm._v("Média Final")]), _vm._v(" "), _c('div', {
      staticClass: "nota"
    }, [_vm._v(_vm._s(item.media_final || '-'))])]) : _vm._e()])])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostrarModalPdf),
      callback: function($$v) {
        _vm.mostrarModalPdf = $$v
      },
      expression: "mostrarModalPdf"
    }
  }, [_c('v-card', {
    staticClass: "modal-pdf"
  }, [_c('v-card-text', [_c('iframe', {
    attrs: {
      "src": _vm.pdfBase64
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalPdf = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "align-center": ""
    },
    model: {
      value: (_vm.mostrarModalDetalheNotas),
      callback: function($$v) {
        _vm.mostrarModalDetalheNotas = $$v
      },
      expression: "mostrarModalDetalheNotas"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalDetalheNotas = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n            AVALIAÇÕES DA ÁREA TEMÁTICA " + _vm._s(_vm.competencias.desc_area_tematica) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.refMatricula) ? [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('h3', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.notasMatriculasAvaliacoes['M' + _vm.refMatricula].dados.descricao))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Professor(a):")]), _vm._v(" " + _vm._s(_vm.notasMatriculasAvaliacoes['M' + _vm.refMatricula].dados.professores.replace(/[0-9]+.-/g, '')) + " ")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify": "center",
      "align-space-around": "",
      "justify-center": "",
      "row": "",
      "fill-height": ""
    }
  }, [(_vm.notasMatriculasAvaliacoes['M' + _vm.refMatricula].avaliacoes.length == 0) ? _c('div', [_c('h4', [_vm._v("Nenhuma nota registrada.")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notasMatriculasAvaliacoes['M' + _vm.refMatricula].avaliacoes), function(avaliacao) {
    return [_c('v-flex', {
      attrs: {
        "sm3": ""
      }
    }, [_c('v-card', {
      staticClass: "ml-2",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-card-title', [_c('strong', [_vm._v(_vm._s(avaliacao[0].avaliacao))])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((avaliacao[0].notas), function(nota) {
      return _c('v-list-tile', [_c('v-list-item-content', {
        staticClass: "align-end"
      }, [_c('strong', [_vm._v("Nota " + _vm._s(nota.numero) + ":")]), _vm._v(" " + _vm._s(nota.nota) + "\n                        ")])], 1)
    }), 1)], 1)], 1)]
  })], 2)] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "align-center": ""
    },
    model: {
      value: (_vm.mostrarModalGrafico),
      callback: function($$v) {
        _vm.mostrarModalGrafico = $$v
      },
      expression: "mostrarModalGrafico"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalGrafico = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n            AVALIAÇÕES DA ÁREA TEMÁTICA " + _vm._s(_vm.competencias.desc_area_tematica) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.competencias.avaliacoes), function(avaliacao) {
    return _c('v-flex', {
      attrs: {
        "d-flex": "",
        "xs12": "",
        "sm12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "mx-2": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary white--text pa-2"
    }, [_c('div', {
      staticClass: "text-right"
    }, [_vm._v("\n                      " + _vm._s(avaliacao.desc_tipo_prova) + "\n                      (Peso: " + _vm._s(avaliacao.peso) + ")\n                      ")])]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table-notas",
      attrs: {
        "id": "dataTableNotas"
      }
    }, [_c('tbody', [_vm._l((avaliacao.notas), function(nota, key) {
      return _c('tr', [_c('td', {
        staticClass: "td-label-notas"
      }, [_vm._v("Nota " + _vm._s(key + 1))]), _vm._v(" "), _c('td', {
        staticClass: "td-notas",
        style: ((avaliacao.descartada ? (avaliacao.descartada[key + 1] ? 'text-decoration: line-through' : '') : ''))
      }, [_vm._v("\n                            " + _vm._s(nota) + "\n                            ")])])
    }), _vm._v(" "), _vm._l(((avaliacao.quantidade_avaliacao - avaliacao.notas.length)), function(i) {
      return ((avaliacao.quantidade_avaliacao >= avaliacao.notas.length)) ? _c('tr', [_c('td', {
        staticClass: "td-label-notas"
      }, [_vm._v("Nota " + _vm._s(++avaliacao.notas.length))]), _vm._v(" "), _c('td', {
        staticClass: "td-notas"
      }, [_vm._v(" - ")])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "td-label-notas"
    }, [_c('strong', [_vm._v("Média")])]), _vm._v(" "), _c('td', {
      staticClass: "td-notas"
    }, [_vm._v(_vm._s(avaliacao.media))])])], 2)]), _vm._v(" "), (avaliacao.numero_descarte) ? _c('v-card-text', {
      staticClass: "pa-1"
    }, [_c('div', [_c('v-chip', {
      staticClass: "ma-0",
      attrs: {
        "color": "orange",
        "label": "",
        "outline": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v(" info ")]), _vm._v(" Nº de notas descartadas " + _vm._s(avaliacao.numero_descarte))], 1)], 1)]) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "d-flex": ""
    }
  }, [_c('v-card', {
    attrs: {
      "mt-2": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_c('strong', [_vm._v("Média Geral: " + _vm._s(_vm.competencias.media_final))])])], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "d-flex": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "d-flex": ""
    }
  }, [_c('highcharts', {
    staticClass: "charts",
    attrs: {
      "options": _vm.chartOptionsMedia
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('highcharts', {
    staticClass: "charts",
    attrs: {
      "options": _vm.chartOptionsAvaliacoes
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%",
      "align-center": ""
    },
    model: {
      value: (_vm.mostrarModalDetalheFrequencia),
      callback: function($$v) {
        _vm.mostrarModalDetalheFrequencia = $$v
      },
      expression: "mostrarModalDetalheFrequencia"
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.refDisciplina) + " - " + _vm._s(_vm.nomeDisciplina))]), _vm._v(" "), _c('div', {
    staticClass: "box-nav"
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "offset-y": "",
      "id": "menu-mostra-legenda"
    }
  }, [_c('v-btn', {
    staticClass: "primary white--text",
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "fas fa-info-circle"
  })]), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', [_c('span', {
    staticClass: "span-presenca"
  }, [_c('i', {
    staticClass: "far fa-smile"
  }), _vm._v(" - Presença")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('span', {
    staticClass: "span-meia-presenca"
  }, [_c('i', {
    staticClass: "far fa-meh"
  }), _vm._v(" - Meia Presença")])])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', [_c('span', {
    staticClass: "span-falta"
  }, [_c('i', {
    staticClass: "far fa-frown"
  }), _vm._v(" - Falta")])])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('v-card', {
    attrs: {
      "id": "card-modal-detalhe-frequencia"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "text-xs-center": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.frequencias), function(meses) {
    return _c('v-flex', {
      attrs: {
        "sm2": "",
        "xs12": "",
        "align-center": ""
      }
    }, [_c('v-card', {
      staticClass: "primary white--text",
      attrs: {
        "hover": ""
      }
    }, [_c('v-card-text', {
      staticClass: "px-0"
    }, [_c('strong', [_vm._v(_vm._s(meses.mes_string))])]), _vm._v(" "), _c('v-list', [_vm._l((meses.frequencias), function(dia, index) {
      return [_c('v-list-tile', {
        key: dia.dt_aula + new Date().getTime()
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('strong', [_vm._v(_vm._s(dia.dia_string))])])], 1), _vm._v(" "), _vm._l((dia.tipos_presencas), function(tipo_presenca) {
        return (tipo_presenca) ? _c('v-list-tile-avatar', [(tipo_presenca === 'presenca') ? _c('span', {
          staticClass: "span-presenca"
        }, [_c('i', {
          staticClass: "far fa-smile"
        })]) : (tipo_presenca === 'meia_presenca') ? _c('span', {
          staticClass: "span-meia-presenca"
        }, [_c('i', {
          staticClass: "far fa-meh"
        })]) : _c('span', {
          staticClass: "span-falta"
        }, [_c('i', {
          staticClass: "far fa-frown"
        })])]) : _vm._e()
      })], 2), _vm._v(" "), ((index + 1) < meses.frequencias.length) ? _c('v-divider') : _vm._e()]
    })], 2)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalDetalheFrequencia = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fc088134!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/academico/components/FrequenciaNotas.vue
// module id = 582
// module chunks = 2